import { Box, Tab, Tabs, Typography, Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { BsArrowLeft } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router";
import Loader from "../../../components/Loader";
import NewPlayerBetSlip from "../../../components/NewPlayerBetSlip";
import { endPoints, sportEndPoint } from "../../../constant/Environment";
import { getAllBetData, getAllData } from "../../../Utility/API";
import {
  getLeagueImageUrl,
  getSportImageUrl,
  checkGeoAndVpn,
} from "../../../Utility/functions/Helper";
import { Actions } from "../../../redux/Actions/Actions";
import MailVerification from "../../MailVerification/notverified";
import FailedGeocheck from "../../FailedGeocheck/index";
import "./playergame.css"
import WheelOfFortune from "../../WheelofFortune";
import { BiSolidOffer,BiSolidGift } from "react-icons/bi";
import { SuccesToast, ErrorToast } from "../../../components/Toast/message";

const PlayerGames = () => {
  const [tabdatevalue, setTabdatevalue] = useState(0);
  const [tabIndexValue, setTabIndexValue] = useState(0);
  const [selectedSport, setSelectedSport] = useState("ECI Hungry");
  const [sportsList, setSportsList] = useState([]);
  const [tabList, setTabList] = useState([]);
  const [contest, setContest] = useState("");
  const state = useSelector((state) => state);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [isLoading, setIsLoadinig] = useState(false);
  const [geoResult, setGeoResult] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
   const [segments, setSegments] = useState([]);
      const [probabilities, setProbabilities] = useState([]);
      const [colors, setColors] = useState([]);
      const [wofData, setWofData] = useState({});
    
      const handleCloseWheel = () => setOpenWheel(false);
      const [openWheel, setOpenWheel] = useState(false);

        const handleOpenWheel = async () => {
        try {
          let url = `${endPoints.api.GET_SPIN_VALUES}/${state?.auth?.user?.idUser || 0}`;
          const response = await getAllData(url);
          if (
            response.status === "success" &&
            response?.data?.segments?.length &&
            response?.data?.probabilities?.length &&
            response?.data?.colors.length
          ) {
            setSegments(response?.data?.segments);
            setProbabilities(response?.data?.probabilities);
            setColors(response?.data?.colors || []);
            setWofData(response?.data);
            setOpenWheel(true); // Opening wheel only when data is coming
          } else {
            SuccesToast("Something went wrong. Please try again later.");
          }
        } catch (err) {
          console.error(err);
          ErrorToast("Something went wrong. Please try again later.");
        }
      };

  const handleDateChange = (e, val) => {
    setTabdatevalue(val);
    const match = tabList[val];
    setSelectedMatch(match);
  };
  const handleMatchChange = (e, val) => setTabIndexValue(val);

  const checkGeoLocation = async () => {
    const result = await checkGeoAndVpn(dispatch);
    dispatch({
      type: Actions.GEO_RESPONSE,
      data: result,
    });
    if (result) {
      console.log("Setting geoResult to true - should show FailedGeocheck");
      setGeoResult(true);
    } else {
      console.log("Setting geoResult to false - should NOT show FailedGeocheck");
      setGeoResult(false);
    }
  };

  useEffect(() => {
    if (!selectedMatch && tabList?.length > 0) {
      setSelectedMatch(tabList[0]);
      setTabdatevalue(0);
    } else if (tabList.length === 0) {
      setSelectedMatch(null);
      setTabdatevalue(0);
    }
  }, [tabList]);

  useEffect(() => {
    const fetchSports = async () => {
      setIsLoadinig(true);
      try {
        const url = sportEndPoint.api.P2P_LEAUGE_LIST; // seprate endpoints for leagues in p2p.
        const allSports = await getAllBetData(url);
        const updatedSports = allSports?.map((sport) => ({
          ...sport,
          label: sport?.name?.replace(/\s/g, "").toLowerCase(),
          img: getLeagueImageUrl(
            sport?.name?.replace(/\s/g, "_").toLowerCase()
          ),
        }));

        setSportsList(updatedSports);

        if (updatedSports?.length > 0) {
          setSelectedSport(updatedSports[0]?.name); // or .id
          fetchTabsBySportId(updatedSports[0]?.id);
        }
      } catch (error) {
        console.error("Failed to fetch sports:", error);
      } finally {
        setIsLoadinig(false);
      }
    };

    fetchSports();
    checkGeoLocation();
  }, []);


  const fetchTabsBySportId = async (sportId) => {
    setIsLoadinig(true);
    try {
      const tabApiUrl = `${
        sportEndPoint.apiBaseUrl + sportEndPoint.api.playerleagueData + sportId
      }`;
      const tabData = await getAllBetData(tabApiUrl);
      setTabList(tabData.dateList); // Set in state
      setContest(tabData?.events);
      setSelectedMatch(tabData?.dateList[0]); // Set the first match as selected
      setTabdatevalue(0); // Reset date tab index
    } catch (error) {
      console.error("Failed to fetch tab data:", error);
    } finally {
      setIsLoadinig(false);
    }
  };

  const location = useLocation();

  const matchName = state?.betslip?.matchName;

  return (
    <>
      <Helmet>
        <title>Play Daily Fantasy Sports | BettDraft</title>
        <meta name="description" content="Pick your players and build your fantasy team. Mix & match NFL, NBA, MLB, NHL and MLS players on BettDraft." />
        <link rel="canonical" href="https://dfs.bettdraft.com/" />
        <meta property="og:title" content="Play Daily Fantasy Sports | BettDraft" />
        <meta property="og:description" content="Pick your players and build your fantasy team. Mix & match NFL, NBA, MLB, NHL and MLS players on BettDraft." />
        <meta property="og:url" content="https://dfs.bettdraft.com/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Play Daily Fantasy Sports | BettDraft" />
        <meta name="twitter:description" content="Pick your players and build your fantasy team. Mix & match NFL, NBA, MLB, NHL and MLS players on BettDraft." />
      </Helmet>
      {/* {isLoading && <Loader visible={isLoading} />}  */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          mt: 1,
        }}
      >
        <Box
          sx={{
            minWidth: { xs: "auto", md: "220px" },
            border: { xs: "none", md: "1px solid #0D3862" },
            height: { xs: "auto", md: "auto" },
            display: "flex",
            flexDirection: { xs: "row", md: "column" },
            overflowX: { xs: "auto", md: "hidden" },
            whiteSpace: { xs: "nowrap", md: "normal" },
            bgcolor: "#f5f5f5",
            p: 1,

            borderRadius: "10px",
            marginTop: { xs: "10px", md: "0px" },
          }}
        >
          {/* Daily Fantasy at top (old design styles) */}
          <Box
            key="alt-line"
            role="button"
            onClick={() => {
              dispatch({ type: Actions.REMOVE_ALL_BETSLIP });
              localStorage.setItem("WEBSITE", "ALTLINE");
              window.location.reload();
            }}
            sx={{
              display: { xs: "none", md: "flex" },
              width: { xs: "auto", md: "200px" },
              border: { xs: "none", md: "1px solid #0D3862" },
              height: { xs: "auto" },
              bgcolor: "#f5f5f5",
              gap: { xs: 0.5, md: 1 },
              cursor: "pointer",
              px: 2,
              py: 1,
              mt: 0,
              mr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
              borderRadius: 1,
              fontWeight: 600,
              "&:hover": {
                bgcolor: "#e0e0e0",
              },
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: 'bold',
                fontSize: "16px",
                  color: "#c02640 !important",
                   textDecoration: "underline",
              }}
            >
              Daily Fantasy
            </Typography>
          </Box>

          {/* Section title */}
          <Typography
            variant="h4"
            sx={{
              paddingBottom: "12px",
              color: "blue",
              fontWeight: "bolder",
              display: { xs: "none", md: "block" },
            }}
          >
            Sports
          </Typography>

          {/* Sports list */}
          {sportsList?.map((sport, i) => (
            <Box
              key={sport.id || i}
              onClick={() => {
                fetchTabsBySportId(sport?.id);
                setSelectedSport(sport?.name);
                navigate("/");
              }}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                gap: { xs: 0.5, md: 1 },
                cursor: "pointer",
                px: 2,
                py: 1,
                mr: { xs: 2, md: 0 },
                mb: { xs: 0, md: 2 },
                borderRadius: 1,
                bgcolor:
                  selectedSport == sport.name ? "#0D3862" : "transparent",
                color: selectedSport == sport.name ? "white" : "black",
                fontWeight: selectedSport == sport.name ? 600 : 400,
                flexShrink: 0,
                "&:hover": {
                  bgcolor: selectedSport === sport.name ? "#0D3862" : "#e0e0e0",
                },
              }}
            >
              <img src={sport.img} alt={sport.name} width={24} height={24} />
              <Typography
                variant="body2"
                sx={{
                  color:
                    selectedSport == sport.name
                      ? "white!important"
                      : "black!important",
                  fontWeight: selectedSport == sport.name ? 600 : 400,
                }}
              >
                {sport.name}
              </Typography>
            </Box>
          ))}
        </Box>

         {/*  has to remove this code when placing button in navbar soleve the problem  */}
         {/* {!(state?.auth?.user?.dailyLoginClaim) && (
                    <div
                      className="mobile-fab"
                      onClick={() => {
                       handleOpenWheel();
                      }}
                      title="Offers"
                    >
                      <button className="fab-btn" aria-label="Offers">
                        <BiSolidGift size={28} />
                      </button>
                    </div>
                    )} */}
        
                    {/* <WheelOfFortune 
                            open={openWheel} 
                            handleClose={handleCloseWheel}
                             onClose={() => setOpenWheel(false)} 
                             wofData={wofData}
                     /> */}

        {/* Main content */}
        <Box sx={{ flexGrow: 1, p: 1 }}>
          
          {/* Email Verification Check */}
          {state?.auth?.user?.verification == "0" ? (
            <MailVerification />
          ) : null}
          
          {/* Geo Location Check */}
          {geoResult && <FailedGeocheck />}
          
          {/* Date tabs */}
          {location.pathname == "/" ? (
            isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  width: { xs: "auto", md: "850px" },
                  p: 1,
                }}
              >
                {[...Array(4)].map((_, i) => (
                  <Skeleton
                    key={i}
                    variant="rectangular"
                    width={100}
                    height={36}
                  />
                ))}
              </Box>
            ) : (
              <Tabs
                value={tabdatevalue}
                onChange={handleDateChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor="primary"
                indicatorColor="primary"
                sx={{ width: { xs: "auto", md: "850px" } }}
              >
                {tabList?.map((date, i) => (
                  <Tab
                    label={date}
                    key={i}
                    sx={{ textTransform: "none" }}
                    onClick={() => {
                      navigate("/");
                    }}
                  />
                ))}
              </Tabs>
            )
          ) : (
            ""
          )}

          {location.pathname != "/" ? (
            <Box display="flex" alignItems="center" gap={1} mt={2}>
              <Typography
                onClick={() => navigate(-1)}
                sx={{
                  color: "#0D3862",
                  p: 0.5,
                  cursor: "pointer",
                }}
              >
                <BsArrowLeft />
              </Typography>
              <Typography
                variant="h6"
                fontWeight={500}
                sx={{
                  fontSize: { xs: "15px", md: "18px" },
                }}
              >
                {/* Match: */}
                {matchName}
              </Typography>
            </Box>
          ) : (
            ""
          )}

          <Box
            mt={2}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
              width: "100%",
            }}
          >
            <Box sx={{ width: { xs: "100%", md: "70%" } }}>
              <Outlet context={{ contest, selectedMatch, isLoading }} />
            </Box>

            <Box
              sx={{
                width: { xs: "100%", md: "30%" },
                display: { xs: "none", md: "block" },
              }}
            >
              <NewPlayerBetSlip />
            </Box>
          </Box>
        </Box>
      </Box>

    </>
  );
};

export default PlayerGames;
